// import logo from "../assets/logo.png";

// function Home() {
//   return (
//     <>
//       <div className="hero">

//         {/* LOGO */}

//         <h1>Radha Traders</h1>

//         <p>
//           Wholesale Supplier Since 2002 <br />
//           Delhi NCR Region <br />
//           Bulk supply of dairy, frozen & non-veg products directly from warehouses.
//         </p>

//         <a
//           href="https://wa.me/917733982109?text=Hello%20I%20am%20interested%20in%20your%20products"
//           className="btn"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Get Wholesale Details
//         </a>
//       </div>

//       <div className="section">
//         <h2>Why Choose Radha Traders</h2>
//         <div className="grid">
//           <div className="card">
//             <h3>Since 2002</h3>
//             <p>Trusted wholesale supply experience.</p>
//           </div>
//           <div className="card">
//             <h3>Bulk Supply</h3>
//             <p>Large volume inventory available.</p>
//           </div>
//           <div className="card">
//             <h3>Direct Warehouse</h3>
//             <p>Fresh stock from manufacturing units.</p>
//           </div>
//           <div className="card">
//             <h3>Delhi NCR Only</h3>
//             <p>Fast and reliable local distribution.</p>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Home;
// import logo from "../assets/logo.png";

function Home() {
  return (
    <>
      <div className="hero">

        <h1>Radha Traders</h1>

        <p>
          Wholesale Supplier Since 2002 <br />
          Delhi NCR Region <br />
          Bulk supply of dairy, frozen & non-veg products directly from warehouses.
        </p>

        <a
          href="https://wa.me/917733982109?text=Hello%20I%20am%20interested%20in%20your%20products"
          className="btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Wholesale Details
        </a>
      </div>
 <div className="section clients-section">
        <h2>Our Top Clients</h2>

        <div className="clients-grid">
          <div className="client-card">Absolute Barbeque</div>
          <div className="client-card">Pirates of Grill</div>
          <div className="client-card">MSC Crew</div>
          <div className="client-card">Stellar Binge Group</div>
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <div className="section">
        <h2>Why Choose Radha Traders</h2>
        <div className="grid">
          <div className="card">
            <h3>Since 2002</h3>
            <p>Trusted wholesale supply experience.</p>
          </div>
          <div className="card">
            <h3>Bulk Supply</h3>
            <p>Large volume inventory available.</p>
          </div>
          <div className="card">
            <h3>Direct Warehouse</h3>
            <p>Fresh stock from manufacturing units.</p>
          </div>
          <div className="card">
            <h3>Delhi NCR Only</h3>
            <p>Fast and reliable local distribution.</p>
          </div>
        </div>
      </div>

      {/* TOP CLIENTS SECTION */}
     
    </>
  );
}

export default Home;